import React from "react";
import { Flex, GridItem, Text } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { FormValues } from "../../duck";
import InputGroup from "../input-group";
import { ORAL_SURGERY_OPTIONS } from "./duck";

const OralSurgery: React.FC = () => {
  const { watch } = useFormContext<FormValues>();
  const oralSurgeryValues = watch("oralSurgeries");

  return (
    <GridItem>
      <Flex direction="column" rowGap="4">
        <Text fontWeight="semibold" color="gray.600">
          Oral Surgery
        </Text>
        <InputGroup
          options={ORAL_SURGERY_OPTIONS}
          values={oralSurgeryValues}
          name="oralSurgeries"
        />
      </Flex>
    </GridItem>
  );
};

export default OralSurgery;
